import { AlertTriangle, CheckCircle2, XCircle, HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLang, fmtDateTime } from "@/i18n";

const TONES = {
  mock: "bg-violet-50 dark:bg-violet-950/40 border-violet-200 dark:border-violet-800 text-violet-800 dark:text-violet-200",
  ok: "bg-emerald-50 dark:bg-emerald-950/40 border-emerald-200 dark:border-emerald-800 text-emerald-800 dark:text-emerald-200",
  fail: "bg-red-50 dark:bg-red-950/40 border-red-200 dark:border-red-800 text-red-800 dark:text-red-200",
  unknown: "bg-amber-50 dark:bg-amber-950/40 border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-200",
};
const ICONS = { mock: AlertTriangle, ok: CheckCircle2, fail: XCircle, unknown: HelpCircle };

export const authErrorText = (auth, t) => {
  if (!auth?.message) return "";
  const k = `err_${auth.message}`;
  return t(k) !== k ? t(k) : auth.message;
};

export const MyDataStatusBanner = ({ mode, auth }) => {
  const { t } = useLang();
  const state = mode === "mock" ? "mock" : !auth ? "unknown" : auth.ok ? "ok" : "fail";
  const Icon = ICONS[state];
  const text = { mock: t("mock_banner"), ok: t("live_banner"), fail: t("auth_fail_banner"), unknown: t("auth_unknown_banner") }[state];
  return (
    <div className={cn("flex items-start gap-3 rounded-md border px-4 py-3 text-sm transition-colors", TONES[state])} data-testid="mydata-mode-banner" data-state={state}>
      <Icon size={16} className="mt-0.5 shrink-0" />
      <div className="space-y-0.5">
        <div className="font-medium" data-testid="mydata-banner-text">{text}</div>
        {state === "fail" && <div className="text-xs opacity-90" data-testid="mydata-banner-error">{authErrorText(auth, t)}</div>}
        {auth?.checked_at && state !== "mock" && <div className="text-xs opacity-75 font-mono" data-testid="mydata-banner-checked-at">{t("last_check")}: {fmtDateTime(auth.checked_at)}</div>}
      </div>
    </div>
  );
};
